import Clientes from "@/views/Clientes.vue";

const clientes = {
  path: "/app/clientes",
  name: "clientes",
  component: Clientes,
};

export default clientes;
